<div [formGroup]="form">
  <div class="section-container" id="impostos-creditados">
    <div class="section-title">
      <mat-icon>trending_up</mat-icon>
      <span>Impostos Creditados</span>
    </div>
    <p class="text-muted small mb-3">Créditos de PIS/COFINS da tomadora · valide o preenchimento com a contabilidade.</p>

    <div class="row mb-3">
      <div class="col-12"><strong>PIS/Pasep</strong></div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>CST</mat-label>
          <mat-select formControlName="pisCreditadoCst">
            <mat-option [value]="null">Selecione...</mat-option>
            @for (opcao of cstsPis; track opcao.codigo) {
            <mat-option [value]="opcao.codigo">{{ opcao.codigo }} - {{ opcao.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Base de Cálculo (R$)</mat-label>
          <input matInput formControlName="pisCreditadoBase" [currencyMask]="dynamicCurrencyMask" (blur)="recalcular('pisCreditado')" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Alíquota (%)</mat-label>
          <input matInput formControlName="pisCreditadoAliquota" [currencyMask]="percentageMask" (blur)="recalcular('pisCreditado')" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor (R$)</mat-label>
          <input matInput formControlName="pisCreditadoValor" [currencyMask]="dynamicCurrencyMask" readonly />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12"><strong>COFINS</strong></div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>CST</mat-label>
          <mat-select formControlName="cofinsCreditadoCst">
            <mat-option [value]="null">Selecione...</mat-option>
            @for (opcao of cstsCofins; track opcao.codigo) {
            <mat-option [value]="opcao.codigo">{{ opcao.codigo }} - {{ opcao.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Base de Cálculo (R$)</mat-label>
          <input matInput formControlName="cofinsCreditadoBase" [currencyMask]="dynamicCurrencyMask" (blur)="recalcular('cofinsCreditado')" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Alíquota (%)</mat-label>
          <input matInput formControlName="cofinsCreditadoAliquota" [currencyMask]="percentageMask" (blur)="recalcular('cofinsCreditado')" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor (R$)</mat-label>
          <input matInput formControlName="cofinsCreditadoValor" [currencyMask]="dynamicCurrencyMask" readonly />
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
